var exports = {
  "h": "OverflowLabel__Rt9K0z",
  "c": "InlineLabel__5QYfWv",
};

module.exports = exports;
